export default "__VITE_ASSET__j074jm5$__"